var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChandelier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6c.4 1.7 1.8 3 4 3s3.6-1.3 4-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13c0 3-2.7 5-6 4.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13c0 3 2.7 5 6 4.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12v4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12v4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 16h2.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 16h2.4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5c-.8 1-.8 1.9 0 2.8.8-.9.8-1.8 0-2.8Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5c-.8 1-.8 1.9 0 2.8.8-.9.8-1.8 0-2.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3v3.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5l1.2 1.2L12 20l-1.2-1.3L12 17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChandelier);
export default __webpack_public_path__ + "static/media/chandelier.5e6765b72e5be00c07e5670706c81f70.svg";
export { ForwardRef as ReactComponent };